import { Address } from './address.interface';

export interface Patient {
  id: number;
  accountId?: number;
  cpf?: string;
  name?: string;
  birthdate?: string;
  mobile?: string;
  email?: string;
  isDeleted?: number;
  planName?: string;
  gender?: string;
  communicarePatientId?: string;
  indicationId?: number;
  hasLegalRepresentative?: boolean;
  representative?: RepresentativePatient;
  addresses?: Address[];
}

export type RepresentativePatient = {
  name: string;
  cpf: string;
  mobile: string;
  relationshipToPatient: ERepresentativeRelationship;
  email?: string;
};

export enum ERepresentativeRelationship {
  PARENT = 'Pai / Mãe',
  SPOUSE = 'Cônjuge',
  CHILD = 'Filho(a)',
  SIBLING = 'Irmão / Irmã',
  GRANDPARENT = 'Avô / Avó',
  AUNT_UNCLE = 'Tio(a)',
  LEGAL_GUARDIAN = 'REPRESENTANTE LEGAL JUDICIAL / PROCURADOR AUTORIZADO',
  OTHER = 'Outro',
}
